// extracted by mini-css-extract-plugin
module.exports = {"root":"c6e8ba5398--root--2n6sx","title":"c6e8ba5398--title--1Z9Np"};